import { FC, useCallback, useEffect, useState } from "react";
import { executionLogSourceAndExecutedByFilterKey } from "../../../../utils/constants/common";

import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { useGetUsersMeExecutionLogsSourcesQuery } from "@/services/cloudchipr.api";
import {
  setExecutionLogFilters,
  setExecutionLogPagination,
} from "@/store/execution-log/executionLogSlice";
import { getExecutionLogThunk } from "@/store/execution-log/thunks/getExecutionLogThunk";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { executionLogFiltersSelector } from "@/store/execution-log/selectors/executionLogFiltersSelector";
import { arrayIsEqual } from "@/utils/arrayIsEqual";
import { DropdownSelectOption } from "@/components/common/select/dropdown-select/utils/types/types";
import { getExecutionLogSourceFilterOption } from "@/components/pages/execution-log/components/header/filters/source-filter/getExecutionLogSourceFilterOption";
import { ExecutionLogSourceFilterHOC } from "@/components/pages/execution-log/components/header/filters/source-filter/ExecutionLogSourceFilterHOC";

export const ExecutionLogSourceFilter: FC = () => {
  const dispatch = useAppDispatch();

  const executionLogFilters = useAppSelector(executionLogFiltersSelector);
  const { data, isLoading } = useGetUsersMeExecutionLogsSourcesQuery();
  const sourceAndExecutedByFilter =
    executionLogFilters?.[executionLogSourceAndExecutedByFilterKey];

  const [options, setOptions] = useState<DropdownSelectOption[]>([]);

  const filterSubmitHandler = useCallback(
    (values: string[]) => {
      const nothingChanged = arrayIsEqual(
        values,
        sourceAndExecutedByFilter ?? [],
      );

      if (nothingChanged) {
        return;
      }

      dispatch(
        setExecutionLogFilters({
          [executionLogSourceAndExecutedByFilterKey]: values,
        }),
      );

      dispatch(setExecutionLogPagination({ page: 0 }));
      dispatch(getExecutionLogThunk({}));
    },
    [dispatch, sourceAndExecutedByFilter],
  );

  useEffect(() => {
    if (!data) {
      return;
    }

    const options =
      data
        ?.filter((option) => option.source && option.name)
        ?.map((option) =>
          getExecutionLogSourceFilterOption(option.name, option.source),
        ) ?? [];

    setOptions(options);
  }, [data]);

  return (
    <ExecutionLogSourceFilterHOC
      options={options}
      setOptions={setOptions}
      onFilterAdd={filterSubmitHandler}
    >
      <DropdownSelect
        label="Executed By"
        options={options}
        values={sourceAndExecutedByFilter ?? []}
        optionsLoading={isLoading}
        submitHandlerOnClose={filterSubmitHandler}
      />
    </ExecutionLogSourceFilterHOC>
  );
};
